// initial state
const state = () => ({
  isMultiple: false,
  enabled: false,
  selected: {}
})

// functionName: (state, getters, rootState) => {}
const getters = {

}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  setIsMultiple ({ commit }, isMultiple) {
    commit('setIsMultiple', isMultiple)
  },
  setEnabled ({ commit }, enabled) {
    commit('setEnabled', enabled)
  },
  setSelected ({ commit }, o) {
    commit('setSelected', o)
  },
  resetGallery ({ commit }) {
    commit('resetGallery')
  }
}

// functionName (state, { param, ... }) {
const mutations = {
  setIsMultiple (state, isMultiple) {
    state.isMultiple = isMultiple
  },
  setEnabled (state, enabled) {
    state.enabled = enabled
  },
  resetGallery (state) {
    state.selected = {}
    state.enabled = false
  },
  setSelected (state, o) {
    if (!state.enabled) {
      return
    }

    if (state.isMultiple === false) {
      state.selected = {}
    }

    const index = state.selected[o.id]
    if (typeof index === 'undefined') {
      state.selected[o.id] = o;
    } else {
      delete state.selected[o.id]
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
